<div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="message != ''">
    <strong>{{message}}</strong>
    <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<mat-card>
    <mat-card-content>
        <div class="center">
            <div>
                <h2 style="font-size: 200%;">Munkalap Módosítás</h2>
            </div>
            <form [formGroup]="form" (submit)="submit()">
                <div>
                    <mat-form-field appearence="fill" style="width: 250px;">
                        <mat-label>Megrendelő</mat-label>
                        <input required matInput type="text" name="customer" formControlName="customer" />
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearence="fill" style="width: 250px;">
                        <mat-label>Megrendelő kód</mat-label>
                        <input required matInput type="text" name="customerCode" formControlName="customerCode" />
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearence="fill" style="width: 250px;">
                        <mat-label>Honnan</mat-label>
                        <input required matInput type="text" name="fromLocation" formControlName="fromLocation" />
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearence="fill" style="width: 250px;">
                        <mat-label>Hová</mat-label>
                        <input required matInput type="text" name="toLocation" formControlName="toLocation" />
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearence="fill" style="width: 250px;">
                        <mat-label>Beton minőség</mat-label>
                        <input required matInput type="text" name="concreteQuality" formControlName="concreteQuality" />
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearence="fill" style="width: 250px;">
                        <mat-label>Beton mennyiség</mat-label>
                        <input required matInput type="text" name="concreteQuantity"
                            formControlName="concreteQuantity" /><span style="margin-left:-25px;">m³</span>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearence="fill" style="width: 250px;">
                        <mat-label>Telefonszám</mat-label>
                        <input required matInput type="text" name="phoneNumber" formControlName="phoneNumber" />
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="fill" style="width: 250px;">
                        <mat-label>Rendszámok</mat-label>
                        <mat-select formControlName="licenseNumbers" [(ngModel)]="chosenLicensePlate" multiple>
                            <mat-option *ngFor="let license of licensePlate" [value]="license">{{license}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="fill" style="width: 250px;">
                        <mat-label>Dátum</mat-label>
                        <input matInput [matDatepicker]="picker" formControlName="date">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field appearance="fill" style="width: 250px;">
                        <mat-label>Időpont</mat-label>
                        <input [(ngModel)]="date" matInput type="time" formControlName="time">
                    </mat-form-field>
                </div>
                <div>
                    <mat-form-field style="width: 300px;" appearence="fill">
                        <mat-label>Komment</mat-label>
                        <textarea matInput formControlName="comment"></textarea>
                    </mat-form-field>
                </div>
                <div mat-dialog-actions class="button">
                    <button mat-raised-button color="primary">Módosít</button>
                    <div class="divider"></div>
                    <button mat-raised-button color="primary" (click)="backToDay()">Vissza</button>
                </div>
            </form>
        </div>
    </mat-card-content>
</mat-card>